import React, { useEffect, useState } from 'react'
import { Row, Col, Tabs } from 'antd'
import Header from './Header.view'
import {
  IconHelper,
  connectApproveUser,
  routersHelper,
  ConnectChat,
  MessageMethod,
  connectRealtimeAPI,
  Reject,
  ChangeNameMod
} from '../../helpers'
import Announcement from './Announcement.view'
import EditAnnouncement from './EditAnnouncement.view'
import Chat from './../Chat/Chat.view'
import { translate } from 'react-i18next'
import _ from 'lodash'
import { useSelector } from 'react-redux';

let usersMe = {}
const Lobby = ({ t, lobbyLists}) => {

  const { TabPane } = Tabs
  const { IconUserChecked, IconInside, IconCloseGray } = IconHelper
  const [isEdit, setIsEdit] = useState(false)
  const { useRouter } = routersHelper
  const router = useRouter()
  const { roomName } = router.query
  const [userInfo, setUserInfo] = useState('')
  const [HistoryMsg, setHistoryMsg] = useState([]);
  const [msg, setMsg] = useState("");
  const [logged, setLogged] = useState(false);
  const [selected, setSelected] = useState('')
  const contextInfo = useSelector(state => state.contextInfo)

  useEffect(() => {

    let f = lobbyLists.filter((i) => i.id === userInfo.id)
    if (f.length <= 0) {
      setLogged(false)
    }


    if (lobbyLists.length <= 0) {
      setLogged(false)
      setUserInfo('')
    }

    connectRealtimeAPI().callMethod("rooms/get", "" + new Date().getTime(), {
      $date: new Date().getTime() - 180 * 24 * 60 * 60,
    }).subscribe(
      (data) => {
        console.log('get room', data)
      }
    )

  }, [lobbyLists, userInfo])

  useEffect(() => {
    onLayoutHeight()
    window.addEventListener('resize', onLayoutHeight);
  })

  // useEffect(() => {
  //   window.location.hash = ''
  // }, [])

  // const CallApi = useCallback( async () => {
  //   const setcID = JSON.parse(localStorage.getItem('DataManager'))
  //   let obj = {
  //     userId: setcID?.chatUserID, 
  //     data: { 
  //       name: contextInfo.name
  //     }
  //   }
  //   let ch = await ChangeNameMod(setcID.chatUserToken, setcID.chatUserID, obj)
  //   console.log('ch',ch)
  // }, [contextInfo])

  // useEffect(() => {
  //   const setcID = JSON.parse(localStorage.getItem('DataManager'))
  //   if ((_.has(contextInfo,'name') && contextInfo.name !== "" ) !== setcID?.name) {
      
  //     CallApi()
  //   }
  // }, [CallApi, contextInfo])


  const onLayoutHeight = () => {
    const navCol = document.getElementsByClassName('nav')
    const loaderCssCol = document.getElementsByClassName('loaderCss')
    const lobbyHeaderCol = document.getElementsByClassName('lobby-header')
    const lobbyTab = document.getElementsByClassName("lobby-tab")
    const lobbyTabUser = document.getElementsByClassName("lobby-tab-user")
    const lobbyAnnouncement = document.getElementsByClassName("lobby-announcement")
    const chatbox = document.getElementsByClassName("reservation-room-lists")
    if (navCol[0] && lobbyHeaderCol[0]) {
      let nav = navCol[0].offsetHeight
      let lobbyHeader = lobbyHeaderCol[0].offsetHeight
      let lobbyAnnouncementHeight = lobbyAnnouncement[0].offsetHeight
      let chatting = chatbox[0]
      const roomList = window.innerHeight - (nav + lobbyHeader)
      lobbyTab[0].style.minHeight = `${roomList}px`
      lobbyTabUser[0].style.height = `${roomList - (lobbyAnnouncementHeight + 60)}px`
      if (loaderCssCol[0]) {
        loaderCssCol[0].style.height = `${roomList - (lobbyAnnouncementHeight + 43)}px`
      }
      if (logged) {
        chatting.style.height = `${roomList - 70}px`
      }
    }
  }

  const join = async (item) => {
    const noti = item.chatRoomID
    setActiveId(noti)
    ConnectChat().emit('chat', item.id, function (data) {
      console.log('chat', data);
      if (data.code === 200) {
        setSelected(item.id)
        setUserInfo(item)
        history(item)
      }

    })


  }

  const history = (item) => {
    localStorage.setItem("chatRoomID", item.chatRoomID)
    removeNoti(item)
    connectRealtimeAPI()
      .callMethod("loadHistory", item.chatRoomID, null, 50, {
        $date: new Date().getTime() - 180 * 24 * 60 * 60,
      })
      .subscribe(
        async (data) => {
          console.log("loadhistory", data);
          if (data.msg === "result") {
            if (data.error === undefined) {
              let hisMesg = data.result.messages
              console.log('newHisMsg', hisMesg)
              const setcID = JSON.parse(localStorage.getItem('DataManager'))
              
              if (contextInfo.name !== setcID?.name) {
                
                let obj = {
                  userId: setcID?.chatUserID, 
                  data: { 
                    name: contextInfo.name
                  }
                }
                let ch = await ChangeNameMod(setcID.chatUserToken, setcID.chatUserID, obj)
                console.log('ch',ch)
              }
              setHistoryMsg(hisMesg?.reverse());
              setLogged(true);
              subscribeMsg(item);

            } else {
              console.log("handle fail here:", data.error.message);
            }
          }
        },
        (err) => {
          console.log("loadhistory fail(may be network)");
          console.log(err);
        },
        () => console.warn("history Completed!")
      );
  };

  const SyncUser = (users) => {
    let usersMeTmp = {}
    users.forEach(a => {
      // console.log('a', a)
      // console.log('me',usersMe)
      if (usersMe[a.id] === undefined) {

        a.lastedChatAt = 0
        usersMeTmp[a.id] = a
        // console.log('undefiend', usersMeTmp[a.id])
      } else {
        usersMeTmp[a.id] = usersMe[a.id]
        usersMeTmp[a.id].name = a.name
        // console.log('not undefined', usersMe[a.id])
      }
    });
    usersMe = usersMeTmp
    return SortMe()

  }

  const SortMe = (item, lastDated) => {

    let userReturn = []
    for (let k in usersMe) {

      if (!_.isUndefined(item)) {
        if (k === item.id) {
          usersMe[k].lastedChatAt = lastDated
        }
      }
      userReturn.push(usersMe[k])

    }
    return _.orderBy(userReturn, ['lastedChatAt', 'createdAt'], ['desc', 'asc']);
  }

  const getActiveId = () => {
    return new Promise((resolve) => {
      resolve(localStorage.getItem('chatRoomID'))
    })
  }
  const setActiveId = (noti) => {
    return new Promise((resolve) => {
      resolve(localStorage.setItem('chatRoomID', noti))
    })
  }


  const subscribeMsg = (item) => {
    //get stream of message:
    connectRealtimeAPI().getSubscription("stream-room-messages", item.chatRoomID, false).subscribe(
      async (m) => {
        console.log("stream-room-messages", m);
        const noti = m.fields?.args[0].rid
        const activeId = await getActiveId()
        if (activeId !== noti) {
          item.showNoti = true
          // try {
          //   const element = document.querySelectorAll(`.${noti} .notification`)
          //   if (element)
          //     element[0].classList.add("noti-active");
          // } catch (err) {
          //   // Do not any
          // }
        }

        SortMe(item, m.fields?.args[0]._updatedAt.$date)

        setHistoryMsg((prev) => {
          console.log("HistoryMsg:", prev);
          let obj = Object.assign(...m.fields.args, { avatar: item.email })
          let filter = prev.filter((i) => i._id === m.fields.args[0]._id)
          let roomid = prev.filter((i) => i.rid === m.fields.args[0].rid)

          if (roomid.length > 0) {
            if (filter.length <= 0) {
              return [...prev, obj];
            } else {
              return [...prev]
            }
          } else if (roomid.length <= 0) {
            return [...prev]
          }


        });
      },
      (err) => console.error('getSubscription', err),
      () => console.warn("subscribeMsg Completed!")
    );
  };

  const removeNoti = (item) => {
    item.showNoti = false
    // try {
    //   const element = document.querySelectorAll(`.${noti} .notification`)
    //   if (element)
    //     element[0].classList.remove("noti-active");
    // } catch (err) {
    //   // Do not any
    // }
  }

  const onConnectApproveUser = (item) => {
    removeNoti(item)
    connectApproveUser(item.id)
  }

  const renderLobbyList = () => {
    return Array.isArray(SyncUser(lobbyLists)) && SyncUser(lobbyLists)
      // .sort((a, b) => {
      //   if (a.createdAt < b.createdAt) return -1
      //   return a.createdAt > b.createdAt ? 1 : 0
      // })
      .map((item, index) => {
        return (
          <div key={index} className={`tab-user ${item.chatRoomID} ${(selected === item.id) && `userSelect`}`}>
            <div onClick={join.bind(this, item)} className="scale-name">

              {item.isMember ? <IconUserChecked /> : <div style={{ width: 20 }} />}
              <span>{item.name}</span>
            </div>
            <div>
              <div className={`notification ${item.showNoti && 'noti-active'}`} />
              <IconInside className="iconInside" onClick={onConnectApproveUser.bind(this, item)} style={{ cursor: 'pointer', margin: '5px' }} />
              {/* <IconWave className="iconWave" style={{ cursor: 'pointer', margin: '5px' }} /> */}
              <IconCloseGray className="iconCloseGray" onClick={Reject.bind(this, item)} style={{ cursor: 'pointer', margin: '5px' }} />
            </div>
          </div>
        )
      })
  }


  const onInputKeydown = (event) => {
    var code = event.keyCode || event.which;
    if (code === 13 && !event.shiftKey) {

      let inputObj = {
        msg: "method",
        method: "sendMessage",
        id: "" + new Date().getTime(),
        params: [
          {
            _id: "" + new Date().getTime(),
            rid: localStorage.getItem("chatRoomID"),//localStorage.getItem('chat'),
            msg: msg
          },
        ],
      }
      //connectRealtimeAPI().sendMessage(inputObj);
      if (msg !== "") {
        MessageMethod(inputObj)
      }

      setMsg('')
      event.preventDefault();
    }
  }

  const unreadNotLoaded = () => {
    // const noti = localStorage.getItem("chatRoomID")
    // removeNoti(noti)
  }

  const handleChangeName = async (item) => {
    try {
      const name = item.name
      const id = item.id
      ConnectChat().emit('chat', item.id, function (data) {
        console.log('chat', data);
        if (data.code === 200) {
          ConnectChat().emit('setProfile', { name, id }, function (res) {
            console.log('setProfile', res);
            if (res.code === 200) {
              setSelected(item.id)
              setUserInfo(item)
              history(item)
            }
          });
        }
  
      })


      

    } catch (err) {
      console.log('err', err)
    }


  }
 
  return (

    <>
      <Row>
        <Col span={24}>
          <Header t={t} roomName={roomName} />
        </Col>
      </Row>
      <Row type="flex" justify="center" className="lobby-content container">
        <Col span={24}>
          <Row>
            <Col xxl={9} xl={10} lg={12} md={12} sm={24} className="lobby-tab">
              <Tabs defaultActiveKey="1">

                <TabPane tab={t("lobby_room_tabs.request_to_join")} key="1" className="lobby-tab-1">
                  <div className="lobby-tab-user">

                    {renderLobbyList()}

                  </div>
                </TabPane>
                {/* <TabPane tab="Request to switch" key="2">
                                    Content of Tab Pane 2
                                </TabPane>
                                <TabPane tab="In conference" key="3">
                                    Content of Tab Pane 3
                                </TabPane>
                                <TabPane tab="In live" key="4">
                                    Content of Tab Pane 4
                                </TabPane> */}
              </Tabs>
              {isEdit
                ? <EditAnnouncement setIsEdit={setIsEdit} />
                : <Announcement setIsEdit={setIsEdit} />
              }

            </Col>


            {
              logged ?
                <Chat

                  msg={msg}
                  setMsg={setMsg}
                  onInputKeydown={onInputKeydown.bind(this)}
                  userInfo={userInfo}
                  handleChatApi={handleChangeName.bind(this)}
                  HistoryMsg={HistoryMsg}
                  unreadNotLoaded={unreadNotLoaded}
                />
                : ""
            }


          </Row>
        </Col>

      </Row>
    </>
  )
}

export default translate()(Lobby)
